import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { GenericNotificationModal } from './generic-notification.component';

@NgModule({
  imports: [SharedModule],
  declarations: [GenericNotificationModal],
})
export class GenericNotificationModalModule {}
